<div class="container-fluid">
  <div class="row top10 no-gutters">
    <div class="col-xs-12 vcenter">
      <h3>COPAs</h3>
    </div>
  </div>

  <hr style="margin-top:2px;margin-bottom:2px" />

  <div class="row top10 no-gutters">
    <aims-common-table
      id="copa-table"
      [header]="header"
      [dataSource]="copas | async"
      [permissions]="tablePermissions"
      [addRowInitialObject]="addRowInitialObject"
      (rowUpdated)="handleRowUpdate($event)"
      (rowAdded)="handleRowAdd($event)"
      [stickyHeader]="true">

      <aims-common-table-dynamic-row id="negotiatedLaborRate">
        <ng-template viewMode let-element >
          {{ element.negotiatedLaborRate | currency: "USD":"symbol":"1.2-4" }}
        </ng-template>

        <ng-template editMode let-element let-dynamicControl="dynamicControl" let-idx="idx" >
          <mat-form-field appearance="fill" class="form-component" class="editable-text-field" >
            <input matInput type="text"
              [formControl]="dynamicControl"
              name="Neg Labor Rate Update"
              class="fullWidth"
              mask="separator.2"
              thousandSeparator=","
              [allowNegativeNumbers]="false"
              placeholder="$"
              prefix="$" />
            </mat-form-field>
          </ng-template>
        </aims-common-table-dynamic-row>

        <aims-common-table-dynamic-row id="nteMaterialCost">
          <ng-template viewMode let-element >
            {{ element.nteMaterialCost| currency: "USD":"symbol":"1.2-4" }}
          </ng-template>

          <ng-template editMode let-element let-dynamicControl="dynamicControl" let-idx="idx" >
            <mat-form-field appearance="fill" class="form-component" class="editable-text-field" >
              <input matInput type="text"
                [formControl]="dynamicControl"
                name="NTE Material Cost"
                class="fullWidth"
                mask="separator.2"
                thousandSeparator=","
                [allowNegativeNumbers]="false"
                placeholder="$"
                prefix="$" >
              </mat-form-field>
            </ng-template>
        </aims-common-table-dynamic-row>

        <aims-common-table-dynamic-row id="nteTransportationCost">
          <ng-template viewMode let-element >
            {{ element.nteTransportationCost| currency: "USD":"symbol":"1.2-4" }}
          </ng-template>

          <ng-template editMode let-element let-dynamicControl="dynamicControl" let-idx="idx" >
            <mat-form-field appearance="fill" class="form-component" class="editable-text-field" >
              <input matInput type="text"
                [formControl]="dynamicControl"
                name="NTE Material Cost"
                class="fullWidth"
                mask="separator.2"
                thousandSeparator=","
                [allowNegativeNumbers]="false"
                placeholder="$"
                prefix="$" >
              </mat-form-field>
            </ng-template>
        </aims-common-table-dynamic-row>
    </aims-common-table>
  </div>
</div>
